import Button from '@klv/atoms/button';

import * as s from './styles/hero.module.scss';

import { MockFlowNode } from '../flows/flowNode';

import linesAndData from '../assets/lines-and-data.webp';
import gradientBackground from '../assets/gradient-background.svg';
import cloudsBackground from '../assets/clouds.webp';
import leftPhone from '../assets/left-phone.webp';
import rightPhone from '../assets/right-phone.webp';
import centerPhone from '../assets/center-phone.webp';


const Phones = ({ fadeIn = false }: { fadeIn?: boolean; }) => (
  <>
    <div className={s.phone + ' ' + (fadeIn ? s.fadeInUp : '')}>
      <MockFlowNode data={{ icon: 'MailOutline', title: 'Abandoned cart VIP email flow' }} />
      <div className={s.mockEdge} />
      <img src={leftPhone} />
    </div>
    <div className={s.phone + ' ' + (fadeIn ? s.fadeInUp : '')}>
      <MockFlowNode data={{ icon: 'MessageOutline', title: 'Multi-channel product recommendation flow' }} />
      <div className={s.mockEdge} />
      <img src={centerPhone} />
    </div>
    <div className={s.phone + ' ' + (fadeIn ? s.fadeInUp : '')}>
      <MockFlowNode data={{ icon: 'MailOutline', title: 'Multi-channel browse abandonment flow' }} />
      <div className={s.mockEdge} />
      <img src={rightPhone} />
    </div>
  </>
);

export const Hero = ({ setPage }: { setPage: (arg: string) => void; }) => (
  <div data-organism="Flows AI Hero" className={s.hero}>
    <div className={s.heroContent + ' ' + s.fadeInUp}>
      <div className="eyebrow">Demo</div>
      <h1 className="h1">Get to know <span className="gradientText">Flows AI</span></h1>
      <div className={s.subtext}>
        Automated flows are the ultimate in set it and forget it—and with Flows AI, the 
        “set it” part just got a whole lot simpler. How simple? Just describe what you 
        want, and Klaviyo AI builds the structure for your entire flow. Check it out.
      </div>
      <Button variant='primary' action={() => setPage('flows')} text="See Flows AI in action" />
    </div>
    <div className={s.dataGradient} style={{ backgroundImage: `url(${linesAndData}), url(${gradientBackground})` }}/>
    <div className={s.clouds} style={{ backgroundImage: `url(${cloudsBackground})` }} />
    <div className={s.phonesWrapper}>
      <div className={s.phones}>
        <Phones fadeIn={true}/>
      </div>
      <div aria-hidden={true} className={s.phones + ' ' + s.phonesHovered}>
        <Phones />
      </div>
    </div>
  </div>
);
